import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import {
  BREAKPOINT,
  CERTIFICATION_ISO_13485,
  CERTIFICATION_B_CORP,
  CERTIFICATION_GOTS,
  CERTIFICATION_GMP,
  CERTIFICATION_CLIMATE_PARTNER,
  CERTIFICATION_A21,
  WAVYLINE
} from '@constants';
import { TextVariant, Typography } from './Typography';

type Props = {};

const Certifications: React.FC<Props> = () => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Typography $variant={TextVariant.Heading4} $mobileVariant={TextVariant.Heading5}>
        {t('components.environmentally-friendly')}
      </Typography>
      <CertificationsWrapper>
        <CertIconsRow>
          <CertIcon src={CERTIFICATION_ISO_13485} />
          <CertIcon src={CERTIFICATION_B_CORP} />
          <CertIcon src={CERTIFICATION_GOTS} />
          <CertIcon src={CERTIFICATION_GMP} />
          <CertIcon src={CERTIFICATION_CLIMATE_PARTNER} />
        </CertIconsRow>

        <WavyLine src={WAVYLINE} />

        <A21Certification>
          <CertIcon src={CERTIFICATION_A21} />
          <Typography $variant={TextVariant.BodyRegularMD} $mobileVariant={TextVariant.BodyRegularSM}>
            {t('components.a21-certification-text')}
          </Typography>
        </A21Certification>
      </CertificationsWrapper>
    </Wrapper>
  );
};

export default Certifications;

const Wrapper = styled.div`
  background-color: ${Colors.mint50};
  display: flex;
  flex-direction: column;
  row-gap: 56px;
  align-items: center;
  padding: 96px 0;

  > p {
    text-align: center;
    max-width: 90vw;
  }
`;

const CertificationsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 32px;
  row-gap: 24px;
  align-items: center;
  width: 1200px;
  max-width: 80vw;

  @media (max-width: ${BREAKPOINT.laptopL}px) {
    flex-direction: column;
    row-gap: 32px;
  }
`;

const CertIconsRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  column-gap: 24px;
  align-items: center;

  @media (max-width: ${BREAKPOINT.mobileL}px) {
    flex-wrap: wrap;
    justify-content: center;
    column-gap: 32px;
    row-gap: 16px;
  }
`;

const WavyLine = styled.img`
  height: 2px;
  width: 100px;
  rotate: 90deg;

  @media (max-width: ${BREAKPOINT.laptopL}px) {
    rotate: 0deg;
    height: 4px;
    width: 200px;
  }
`;
const CertIcon = styled.img`
  height: 80px;
  width: auto;

  @media (max-width: ${BREAKPOINT.tablet}px) {
    height: 64px;
  }
`;

const A21Certification = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 16px;

  > p {
    max-width: 280px;
  }
`;
